import r, { OPTIONS as D } from "../../managers/braze-instance.js";
import ControlMessage from "../models/control-message.js";
import HtmlMessage from "../models/html-message.js";
import InAppMessage from "../models/in-app-message.js";
import SlideUpMessage from "../models/slide-up-message.js";
import be from "../display/get-animation-effect.js";
import $e from "../display/in-app-message-to-html.js";
import { logInAppMessageImpression } from "../log-in-app-message-impression.js";
import {
  ORIENTATION as Ue,
  WindowUtils as no,
} from "../../util/window-utils.js";
import { isURIJavascriptOrData as tt } from "../../util/url-utils.js";
import { KeyCodes as Ce } from "../../util/key-codes.js";
import { setupInAppMessageUI as ss } from "../../ui/js/index.js";
import { logger as E } from "../../../shared-lib/index.js";
import { toRgba as ke } from "../../util/color-utils.js";
import { isIFrame as At } from "../utils/in-app-message-utils.js";
import Me from "../../l10n/l10n-manager-factory.js";
export function showInAppMessage(e, t, s) {
  if (!r.rr()) return;
  if ((ss(), null == e)) return !1;
  if (e instanceof ControlMessage)
    return (
      E.info(
        "User received control for a multivariate test, logging to Braze servers.",
      ),
      logInAppMessageImpression(e),
      !0
    );
  if (!(e instanceof InAppMessage)) return !1;
  if (e.constructor === InAppMessage) return !1;
  e.Lh();
  const o = e instanceof HtmlMessage;
  if (o && !e.trusted && !r.nr())
    return (
      E.error(
        'HTML in-app messages are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these messages.',
      ),
      !1
    );
  if ((null == t && (t = document.body), e.zo())) {
    if (t.querySelectorAll(".ab-modal-interactions").length > 0)
      return (
        E.info(
          `Cannot show in-app message ${e.message} because another message is being shown.`,
        ),
        !1
      );
  }
  if (no.Ua()) {
    const t = no.Ma();
    if (
      (t === Ue.PORTRAIT &&
        e.orientation === InAppMessage.Orientation.LANDSCAPE) ||
      (t === Ue.LANDSCAPE &&
        e.orientation === InAppMessage.Orientation.PORTRAIT)
    ) {
      const s = t === Ue.PORTRAIT ? "portrait" : "landscape",
        o =
          e.orientation === InAppMessage.Orientation.PORTRAIT
            ? "portrait"
            : "landscape";
      return (
        E.info(
          `Not showing ${o} in-app message ${e.message} because the screen is currently ${s}`,
        ),
        !1
      );
    }
  }
  if (!r.nr()) {
    let t = !1;
    if (e.buttons && e.buttons.length > 0) {
      const s = e.buttons;
      for (let e = 0; e < s.length; e++)
        if (s[e].clickAction === InAppMessage.ClickAction.URI) {
          const o = s[e].uri;
          t = tt(o);
        }
    } else e.clickAction === InAppMessage.ClickAction.URI && (t = tt(e.uri));
    if (t)
      return (
        E.error(
          'Javascript click actions are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these actions.',
        ),
        !1
      );
  }
  const i = document.createElement("div");
  if (
    ((i.className = "ab-iam-root v3"),
    (i.className += be(e)),
    e.language && !o && (i.lang = e.language),
    e._o() && (i.id = e.htmlId),
    r.re(D.$a) && (i.style.zIndex = (r.re(D.$a) + 1).toString()),
    t.appendChild(i),
    e.Mo())
  ) {
    const t = document.createElement("style");
    (t.innerHTML = e.css),
      (t.id = e.Oo()),
      null != r.re(D.er) && t.setAttribute("nonce", r.re(D.er)),
      document.getElementsByTagName("head")[0].appendChild(t);
  }
  const n = e instanceof SlideUpMessage,
    a = $e(
      e,
      (t) => {
        if (e.zo() && e.od()) {
          const s = document.createElement("div");
          if (
            ((s.className = "ab-page-blocker"),
            e.Mo() || (s.style.backgroundColor = ke(e.frameColor)),
            r.re(D.$a) && (s.style.zIndex = r.re(D.$a).toString()),
            i.appendChild(s),
            !r.re(D.Oh))
          ) {
            const o = new Date().valueOf();
            s.onclick = (s) => {
              new Date().valueOf() - o > InAppMessage.bh &&
                (e.ll(t), s.stopPropagation());
            };
          }
          i.appendChild(t), t.focus(), e.ah(i);
        } else if (n) {
          const s = document.querySelectorAll(".ab-slideup");
          let o = null;
          for (let e = s.length - 1; e >= 0; e--)
            if (s[e] !== t) {
              o = s[e];
              break;
            }
          if (e.slideFrom === InAppMessage.SlideFrom.TOP) {
            let e = 0;
            null != o && (e = o.offsetTop + o.offsetHeight),
              (t.style.top = Math.max(e, 0) + "px");
          } else {
            let e = 0;
            null != o &&
              (e =
                (window.innerHeight || document.documentElement.clientHeight) -
                o.offsetTop),
              (t.style.bottom = Math.max(e, 0) + "px");
          }
        } else if (o && !r.re(D.Oh)) {
          const s = e;
          At(t) &&
            t.contentWindow &&
            t.contentWindow.addEventListener("keydown", function (e) {
              e.keyCode === Ce.Ih && s.closeMessage();
            });
        }
        logInAppMessageImpression(e),
          e.dismissType === InAppMessage.DismissType.AUTO_DISMISS &&
            setTimeout(() => {
              i.contains(t) && e.ll(t);
            }, e.duration),
          "function" == typeof s && s();
      },
      (e) => {
        E.info(e);
      },
      r.re(D.Ja),
      r.re(D.$a),
      r.re(D.er),
      t,
      Me.ra().Ta(),
    );
  return (o || n) && (i.appendChild(a), e.ah(i)), !0;
}
